var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStandbyEv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 29,
    fill: "#D946EF",
    fillOpacity: 0.22,
    style: {
      fill: "#D946EF",
      fill: "color(display-p3 0.8510 0.2745 0.9373)",
      fillOpacity: 0.22
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 18,
    fill: "black",
    fillOpacity: 0.13,
    style: {
      fill: "black",
      fillOpacity: 0.13
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 14,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9682_751)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 10,
    fill: "#D946EF",
    style: {
      fill: "#D946EF",
      fill: "color(display-p3 0.8510 0.2745 0.9373)",
      fillOpacity: 1
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9682_751",
    x: 16,
    y: 17,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9682_751"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9682_751",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandbyEv);
export default __webpack_public_path__ + "static/media/standby_ev.83a6d5bcf6dc6f6dbbe2f8c92d0e9bdc.svg";
export { ForwardRef as ReactComponent };